module.exports = __webpack_public_path__ + "static/media/thumbs-up.61b627a2.svg";